import hyperdom from 'hyperdom'
import tripNotes from './tripNotes.jsx'
import assetPath from './assetPath.js'

export default class TripDetails {
  constructor ({
    departure,
    modals,
    summary,
    content,
    config,
  }) {
    this.departure = departure
    this.summary = summary
    this.modals = modals
    this.content = content
    this.config = config
    this.segments = []
    this.mapParams = {
      showMobileMapLegend: false,
      scale: 1.0,
      lastScale: 1.0,
      mousePos: {
        x: 0,
        y: 0,
      },
      translate: {
        x: 0,
        y: 0,
      },
    }
  }

  showReviewTripDetails (mapUrl) {
    return this.content && this.content.itinerary
      ? this.showItinerary(mapUrl)
      : undefined
  }

  toogleAllItinerarySection (close) {
    const elems = document.getElementsByClassName('detailed-itinerary-header')
    this.segments.forEach(segment => segment.isExpanded = close)
    Array.from(elems).forEach(elem => elem.click())
  }

  renderTripNotes () {
    return this.departure.notes
    && this.departure.notes.length > 0
    && this.departure.notes.filter(n => n.departureNote || n.productNote || n.sellingCompanyNote).length > 0
      ? <div className="booking-summary-itinerary__notes">
        <h5 className="booking-summary-itinerary__notes-title">Important Trip Notes</h5>
        {
          tripNotes(this.departure.notes)
        }
      </div>
      : undefined
  }

  renderMap (mapUrl) {
    const clampValue = (x, min, max) => Math.max(min, Math.min(max, x))

    const setMapParams = () => {
      const map = document.querySelector('.booking-summary-itinerary__map-container-image')

      this.mapParams.scale = clampValue(this.mapParams.scale, 1, 3)

      const border = {
        x: (map.clientWidth * (this.mapParams.scale - 1)) / 2,
        y: (map.clientHeight * (this.mapParams.scale - 1)) / 2,
      }
      this.mapParams.translate.x = clampValue(this.mapParams.translate.x, -border.x, border.x)
      this.mapParams.translate.y = clampValue(this.mapParams.translate.y, -border.y, border.y)

      if (this.mapParams.scale === 1) {
        this.mapParams.translate = {x: 0, y: 0}
      }

      map.style.transform = `translate(${this.mapParams.translate.x}px, ${this.mapParams.translate.y}px) scale(${this.mapParams.scale})`
      map.style['transition-property'] = this.mapParams.scale === this.mapParams.lastScale ? 'none' : 'transform'
      map.style['transition-duration'] = this.mapParams.scale === this.mapParams.lastScale ? '0s': '0.2s'
      map.style.cursor = this.mapParams.scale === 1 ? 'default' : 'move'

      this.mapParams.lastScale = this.mapParams.scale
    }
    const zoom = (ev, value) => {
      ev.preventDefault()
      if (ev.type === 'click') {
        this.mapParams.scale += value
      } else if (ev.type === 'wheel') {
        this.mapParams.scale += ev.wheelDeltaY * value
      }

      setMapParams()
    }

    const dragHandler = (ev) => {
      ev.preventDefault()
      this.mapParams
      if (this.mapParams.scale > 1) {
        const touch = ev.touches && ev.touches[0]
        this.mapParams.mousePos.x = ev.clientX || touch.clientX
        this.mapParams.mousePos.y = ev.clientY || touch.clientY
        document.onmouseup = stopDragHandler.bind(this)
        document.onmousemove = dragElement.bind(this)
        document.ontouchend = stopDragHandler.bind(this)
        document.ontouchmove = dragElement.bind(this)
      }
    }

    function dragElement (ev) {
      ev.preventDefault()
      const touch = ev.touches && ev.touches[0]
      const clientX = ev.clientX || touch.clientX
      const clientY = ev.clientY || touch.clientY
      this.mapParams.translate.x += clientX - this.mapParams.mousePos.x
      this.mapParams.translate.y += clientY - this.mapParams.mousePos.y
      setMapParams()
      this.mapParams.mousePos.x = clientX
      this.mapParams.mousePos.y = clientY
    }

    function stopDragHandler (ev) {
      ev.preventDefault()
      document.onmouseup = null
      document.onmousemove = null
      document.ontouchend = null
      document.ontouchmove = null
    }

    const getDetailedItinerary = (element) => {
      if (element.classList.contains('booking-summary-itinerary__map-legend')) {
        return element
      }
      return getDetailedItinerary(element.parentElement)
    }
    const clickHandler = (ev) => {
      ev.preventDefault()
      this.mapParams.showMobileMapLegend = !this.mapParams.showMobileMapLegend

      const parent = getDetailedItinerary(ev.target.parentElement)
      const children = parent.children
      children[1].style.top = `${children[0].offsetHeight}px`

      if (this.mapParams.showMobileMapLegend) {
        parent.style.gridTemplateRows = `auto ${children[1].offsetHeight}px`
      } else {
        parent.style.gridTemplateRows = `auto 0px`
      }
    }

    return mapUrl ? <div className='booking-summary-itinerary__map'>
      <h3 className='booking-summary-itinerary__map-title'>Trip map</h3>
      <div className='booking-summary-itinerary__map-container'>
        <div className="booking-summary-itinerary__map-container-wrapper" onmousedown={(ev) => {dragHandler(ev)}} ontouchstart={(ev) => {dragHandler(ev)}} onwheel={(ev) => zoom(ev, 0.001)}>
          <div className='booking-summary-itinerary__map-container-image' style={`background-image: url(${mapUrl})`}></div>
        </div>
        <div className="booking-summary-itinerary__map-container-actions">
          <button className='booking-summary-itinerary__map-container-actions--zoom-in' onclick={(ev) => zoom(ev, 0.3)}></button>
          <button className='booking-summary-itinerary__map-container-actions--zoom-out' onclick={(ev) => zoom(ev, -0.3)}></button>
        </div>
        <div className='booking-summary-itinerary__map-legend'>
          <div className="booking-summary-itinerary__map-legend-header" onclick={(ev) => clickHandler(ev)}>
            <h3 className="booking-summary-itinerary__map-legend-header-title">
              Legend
              <img
                className={['booking-summary-itinerary__map-legend-header__icon', {'open': this.mapParams.showMobileMapLegend}]}
                src={assetPath(`/public/img/arrow.svg`)}
                alt="arrow-up-down"
              />
            </h3>

          </div>
          <div class="booking-summary-itinerary__map-legend-items">
            {this.config.itineraryMapLegend.map((legendItem) => {
              return <div className='booking-summary-itinerary__map-legend-item'>
                <img className='booking-summary-itinerary__map-legend-icon' src={assetPath(`/public/img/${this.config.styleCode}/itineraryIcons/${legendItem.icon}`)}/>
                <span className='booking-summary-itinerary__map-legend-text'>{legendItem.text}</span>
              </div>
            })}
          </div>
        </div>
      </div>
    </div> : undefined
  }

  renderLocation (location, index) {
    if (index === 0) {
      return <span>{location.name}</span>
    }
    return <span>
      <img
        className="local_offer__icon"
        src={assetPath(`/public/img/itinerary-location-arrow.svg`)}
        alt="local-offer"
      />
      {location.name}
    </span>
  }

  renderItinerarySegment (segment) {
    const getDetailedItinerary = (element) => {
      if (element.classList.contains('detailed-itinerary')) {
        return element
      }
      return getDetailedItinerary(element.parentElement)
    }

    const clickHandler = (ev) => {
      ev.preventDefault()
      segment.isExpanded = !segment.isExpanded

      const parent = getDetailedItinerary(ev.target.parentElement)
      const children = parent.children
      children[1].style.top = `${children[0].offsetHeight}px`

      if(segment.isExpanded){
        parent.style.gridTemplateRows = `auto ${children[1].offsetHeight}px`
      } else {
        parent.style.gridTemplateRows = `auto 0px`
      }
    }

    return <div className={['detailed-itinerary', {'expanded': segment.isExpanded}]}>
      <div
        className={['detailed-itinerary-header', {'expanded': segment.isExpanded}]}
        onclick={(ev) => clickHandler(ev)}
      >
        <h2 className="detailed-itinerary-header__day">Day {segment.startDay}</h2>
        <h1 className="detailed-itinerary-header__title">{segment.title}</h1>
        <div className="detailed-itinerary-header__location">
          {segment.locationsVisited.map((location, index) => this.renderLocation(location, index))}
        </div>
        <img
          className={['detailed-itinerary-header__icon', {'open': segment.isExpanded}]}
          src={assetPath(`/public/img/arrow.svg`)}
          alt="arrow-up-down"
        />
      </div>
      <div className={['detailed-itinerary-content', {'expanded': segment.isExpanded}]}>
        <div class="detailed-itinerary-content__header">
          <h2 className="detailed-itinerary-content__header-day">Day {segment.startDay}</h2>
          <h1 className="detailed-itinerary-content__header-title">{segment.title}</h1>
        </div>
        <p className="detailed-itinerary-content__description">{segment.text.join(' ')}</p>
        {segment.meals.length || segment.accommodation ? <div className="detailed-itinerary-content__extras">
          {segment.accommodation ? <div className="detailed-itinerary-content__extras-accommodation">
            <div className="detailed-itinerary-content__extras-accommodation-header">
              <img
                className="detailed-itinerary-content__extras-accommodation-icon"
                src={assetPath('/public/img/itinerary-accommodation.svg')}
                alt="accomodation-icon"
              />
              <span className="detailed-itinerary-content__extras-accommodation-title">Accommodation</span>
            </div>
            <span className="detailed-itinerary-content__extras-accommodation-content">{segment.accommodation}</span>
          </div> : null}
          {segment.meals.length ? <div className="detailed-itinerary-content__extras-meals">
            <div className="detailed-itinerary-content__extras-meals-header">
              <img
                className="detailed-itinerary-content__extrasmeals-icon"
                src={assetPath('/public/img/itinerary-meals.svg')}
                alt="meals-icon"
              />
              <span className="detailed-itinerary-content__extras-meals-title">Included Meals</span>
            </div>
            <span className="detailed-itinerary-content__extras-meals-content">{segment.meals.join(", ")}</span>
          </div> : null}
        </div>: null}
      </div>
    </div>
  }

  showItinerary (mapUrl) {
    this.new = true
    const close = (ev) => {
      ev.preventDefault()
      this.modals.close().then(() => this.summary.setOnTop(true))
    }
    this.summary.setOnTop(false)
    this.segments = JSON.parse(JSON.stringify(this.content.itinerary))

    const expandAll = (ev) => {
      ev.preventDefault()
      return this.toogleAllItinerarySection(false)
    }
    const closeAll = (ev) => {
      ev.preventDefault()
      return this.toogleAllItinerarySection(true)
    }

    return this.modals.show({
      classNames: ['slideInBottom'],
      closingAnimation: 'slideOutBottom',
      animationDuration: 500,
      fullscreen: true,
      render: () => <div className="itinerary-map-modal">
        <div className="modal__header">
          <h3>TRIP ITINERARY & MAP</h3>
          <i className="modal__exit" onclick={close}></i>
        </div>
        <div class="booking-summary-itinerary">
          <div className="booking-summary-itinerary__header">
            <h1 className="booking-summary-itinerary__header-title">{this.departure.name}</h1>
            <h3 className="booking-summary-itinerary__header-subtitle">{this.departure.brochureName}</h3>
          </div>
          {this.renderTripNotes()}
          {this.renderMap(mapUrl)}
          <div className="booking-summary-itinerary__details">
            <div className="booking-summary-itinerary__details-header">
              <h3 className="booking-summary-itinerary__details-header-title">Detailed itinerary</h3>
              <div className="booking-summary-itinerary__details-header-actions">
                <button
                  class="booking-summary-itinerary__details-header-actions--expand"
                  onclick={ev => expandAll(ev)}
                >
                  Expand All
                </button>
                <div className="booking-summary-itinerary__details-header-actions--divider"></div>
                <button
                  class="booking-summary-itinerary__details-header-actions--close"
                  onclick={ev => closeAll(ev)}
                >
                  Close All
                </button>
              </div>
            </div>
            <div className="booking-summary-itinerary__details-summary">
              <div className="booking-summary-itinerary__details-summary-items">
                {this.segments.map(segment => this.renderItinerarySegment(segment))}
              </div>
            </div>
          </div>
        </div>
      </div>,
    })
  }
}
